// src/data/tenantFlag.ts
// Drapeau de build : vrai UNIQUEMENT dans le build CGE-GUI (`npm run build:cgegui`,
// qui pose REACT_APP_HOME_VITRINE_SLUG=cgegui). Sert à isoler tout le contenu
// codé en dur CGE-GUI (gouvernance, actualités, événements, émissions, activités,
// galerie, témoignages, logos) pour qu'il n'apparaisse JAMAIS dans le build
// principal, EEC ou tout autre tenant partageant les composants `PublicPatronat`.
// Comme c'est une constante de build, le contenu CGE-GUI est éliminé (tree-shaking)
// des autres builds.
export const IS_CGEGUI = process.env.REACT_APP_HOME_VITRINE_SLUG === 'cgegui';

/**
 * Drapeau de build : ce build sert une vitrine à la racine — donc un PATRONAT.
 *
 * `IS_CGEGUI` nomme un tenant ; celui-ci nomme une CATÉGORIE. C'est lui qu'il
 * faut employer pour tout ce qui relève du socle « Vitrine Patronat », afin
 * qu'un second patronat en hérite sans une ligne de code.
 *
 * La catégorie réelle (`categorieEntite === 'patronat'`) n'est connue qu'à
 * l'exécution, avec la réponse de l'API : ce drapeau dit seulement que le
 * build EXPOSE une vitrine. Les pages vérifient la catégorie ensuite.
 */
export const IS_PATRONAT = Boolean(process.env.REACT_APP_HOME_VITRINE_SLUG);
